export default "__VITE_ASSET__CUnI__bd__"